import { useAcsFetch } from '../hooks/use-acs-fetch'
import { Product } from '../types'

export const useProductsApi = (): {
  fetchProducts: () => Promise<Product[]>
} => {
  const acsFetch = useAcsFetch()

  // istanbul ignore next // we have tests for this already but we have to update them once we remove the FF
  const fetchProducts = async (): Promise<Product[]> => {
    const response = await acsFetch<{ products: Product[] }>(
      '/v1/bank-accounts/product?return=promotions',
    )
    if (response.data && response.data.products) {
      return response.data.products
    }
    throw new Error('No products in successful response')
  }

  return { fetchProducts }
}
